import React,{useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveProfile } from '../../store/reducers/profileReducer';
import './Multiple.css';
import Spinner from './../Spinner';
import { showAlert } from '../../store/reducers/alertReducer';


const ProceedButton = ({ profileFormData, amount, btnText }) => {
  
  const priceDataAmount = useSelector(state => state.priceList?.apiResponse?.data?.amount || 0);
  const profileLoading = useSelector(state => state.profileList?.profileLoader);
  const purchasedData = useSelector(state => state.profileList?.planPurchasedData);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const planAmount = amount !== undefined && amount !== null ? amount : priceDataAmount;
  console.log("profileFormDataprofileFormDataprofileFormDataprofileFormData",profileFormData);
  
  const handleProceed = () => {
    if (btnText === 'Proceed to Pay') {
      dispatch(saveProfile(profileFormData))
        .unwrap()
        .then((response) => {
          if(response?.success && response?.subscription == 1){
          }else if (response?.message){
            dispatch(showAlert({ type: 'error', message: response?.message }));
          }
        })
        .catch((error) => {
          console.error('Error saving profile:', error);
          dispatch(showAlert({ type: 'error', message: 'Failed to save profile. Please try again.' }));
        });
  
        console.log("localFormDatalocalFormDataprofileFormData",profileFormData);
      
    }else{
      navigate('/customer-profile');
    }
    
  };


  // Redirect to payment URL once available
  useEffect(() => {
    console.log("purchasedDatapurchasedDatapurchasedData",purchasedData);
    if (purchasedData?.data?.PaymentLink) {
      localStorage.removeItem("customerProfile");
      window.location.href = purchasedData?.data?.PaymentLink; //purchasedData.data.PaymentLink;
    }
  }, [purchasedData]);

  return (
    <div className="fixed-footer">
      <div className="price-info">
        <span className="reupee">₹{planAmount}</span>
        <span className="gst">(Incl. GST)</span>
      </div>
      <button className="proceed-button" onClick={handleProceed} disabled={profileLoading}>
            {profileLoading ? (
              <Spinner />
            ) : (
              <>
                {btnText ? btnText : "Proceed"}
                <img
                  src={`${process.env.PUBLIC_URL}/assets/proceed_arrow.svg`}
                  alt="Proceed Pay"
                  className="proceed-arrow"
                />
              </>
            )}
      </button>

    </div>
  );
};

export default ProceedButton;
